<header>
    <div class="max-width-container">
        <app-landing-navbar></app-landing-navbar>
    </div>
</header>
<main>
    <section class="banner-section">
        <div class="app-banner">
            <div class="app-banner-text">
                <p class="app-banner-heading">
                    {{ 'landing.banner.heading' | transloco }}
                </p>
                <div class="app-banner-subheading">
                    <span> {{ 'landing.banner.subheading' | transloco }} </span>
                    <a href="radish.coop/restaurants" class="app-banner-link">radish.coop/restaurants</a>&nbsp;
                    <span>🚀</span>
                </div>
            </div>
        </div>
    </section>

    <section class="hero-section">
        <div class="hero-section-container max-width-container">
            <div class="hero-cta" [style.--cta-scale]="getHeroCtaScale('landing.hero.prefix' | transloco)">
                <h1 class="hero-cta-header">
                    {{ 'landing.hero.prefix' | transloco }}
                    <span class="roles-container">
                        <span class="role" [@wordInOut]="wordAState">{{ wordA }}&nbsp;</span>
                        <span class="role" [@wordInOut]="wordBState">{{ wordB }}&nbsp;</span>
                    </span>
                    {{ 'landing.hero.suffix' | transloco }}
                </h1>

                <p class="hero-content body-xlarge">
                    {{ 'landing.hero.content' | transloco }}
                </p>
                <div class="button-row">
                    <a href="{{ 'landing.navbar.solutions.lastMile.href' | transloco }}" target="_blank"
                        rel="noopener noreferrer" class="rad-btn-large rad-btn-default">
                        {{ 'landing.cta.shipWithRadish' | transloco }}
                    </a>
                    <button class="rad-btn-large rad-btn-cta"
                        [routerLink]="'/' + translate.getActiveLang() + '/restaurants'">
                        <span>{{ 'landing.cta.orderFood' | transloco }}</span>
                    </button>
                </div>
            </div>

            <div class="stack">
                @for(img of stackImages; track img.src) {
                <img class="stack-img" [class]="img.state" [src]="img.src" [style.--angle]="img.angle + 'deg'"
                    [style.zIndex]="img.zIndex" />
                }
            </div>
        </div>
    </section>

    <section class="manifesto-section">
        <div class="manifesto-section-container max-width-container">
            <div class="intro-container">
                <h2 class="manifesto-header">{{ 'landing.manifesto.header' | transloco }}</h2>
                @for (paragraph of 'landing.manifesto.body' | transloco; track $index) {
                <p class="body-hyper intro-content">{{ paragraph }}</p>
                }
            </div>
            <div class="manifesto-container">
                <p class="body-hyper radish-small-title" style="color:#FF6879;">{{ 'landing.manifesto.radicalDelivery' |
                    transloco }}</p>
                <h2 class="manifesto-header">{{ 'landing.manifesto.builtDiff' | transloco }}</h2>
                <div class="models-container">
                    <div class="intro-model" *ngFor="let model of models; let i = index" #modelRefs>
                        <img class="model-image" [src]="model.image" />
                        <h3 class="model-title">{{ model.title }}</h3>
                        <p class="model-content body-xlarge">{{ model.content }}</p>
                    </div>
                </div>

                <div class="pagination-dots-container">
                    <span class="pagination-dot" *ngFor="let model of models; let i = index"
                        [class.active]="activeModelIndex === i">
                    </span>
                </div>
            </div>
        </div>
    </section>
    <section class="testimonial-section">
        <div class="testimonial-container">
            <div class="testimonial-section-container max-width-container">
                <div class="testimonial-header">
                    <div style="width:fit-content">
                        <p class="body-hyper radish-small-title" style="color: #C9072E;">{{ 'landing.testimonials.hyper'
                            | transloco }}</p>
                        <h2 class="section-title">{{ 'landing.testimonials.title' | transloco }}</h2>
                    </div>
                </div>

                <div class="radically-trusted-shadow-bleed">
                    <div class="radically-trusted-slider">
                        <div class="radically-trusted-container" *ngFor="let t of testimonials; index as i"
                            [class.active]="i === currentTestimonialIndex" [class.prev]="i === prevTestimonialIndex"
                            [class.next]="i === nextTestimonialIndex">
                            <img class="radically-trusted-img" [src]="t.image" (click)="openLink(t.readMoreUrl)" />
                            <div class="radically-trusted-content">
                                <img class="radically-trusted-content-img" [src]="t.logo" />
                                <h2 class="radically-trusted-content-quote"
                                    [style.--quote-scale]="getTestimonialScale(t.quote)">
                                    {{ getTestimonialQuote(t.quote) }}
                                </h2>
                                <p class="body-hyper radically-trusted-content-quote-from">
                                    — {{ t.from }}
                                </p>
                                <a [href]="t.readMoreUrl" target="_blank" class="read-more">
                                    <h5>{{ 'landing.testimonials.readMore' | transloco }}</h5>
                                    <svg class="arrow-right" xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                                        <path
                                            d="M566.6 342.6C579.1 330.1 579.1 309.8 566.6 297.3L406.6 137.3C394.1 124.8 373.8 124.8 361.3 137.3C348.8 149.8 348.8 170.1 361.3 182.6L466.7 288L96 288C78.3 288 64 302.3 64 320C64 337.7 78.3 352 96 352L466.7 352L361.3 457.4C348.8 469.9 348.8 490.2 361.3 502.7C373.8 515.2 394.1 515.2 406.6 502.7L566.6 342.7z" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="paginator body-hyper">
                    <button class="paginator-btn" (click)="prevSlide(true)">
                        <svg class="paginator-icon" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                            <path
                                d="M566.6 342.6C579.1 330.1 579.1 309.8 566.6 297.3L406.6 137.3C394.1 124.8 373.8 124.8 361.3 137.3C348.8 149.8 348.8 170.1 361.3 182.6L466.7 288L96 288C78.3 288 64 302.3 64 320C64 337.7 78.3 352 96 352L466.7 352L361.3 457.4C348.8 469.9 348.8 490.2 361.3 502.7C373.8 515.2 394.1 515.2 406.6 502.7L566.6 342.7z" />
                        </svg>
                    </button>
                    <div class="paginator-detail">
                        {{ currentTestimonialIndex + 1 }}/{{ totalSlides }}
                    </div>
                    <button class="paginator-btn" (click)="nextSlide(true)">
                        <svg class="paginator-icon" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                            <path
                                d="M73.4 297.4C60.9 309.9 60.9 330.2 73.4 342.7L233.4 502.7C245.9 515.2 266.2 515.2 278.7 502.7C291.2 490.2 291.2 469.9 278.7 457.4L173.3 352L544 352C561.7 352 576 337.7 576 320C576 302.3 561.7 288 544 288L173.3 288L278.7 182.6C291.2 170.1 291.2 149.8 278.7 137.3C266.2 124.8 245.9 124.8 233.4 137.3L73.4 297.3z" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </section>
    <section class="cta-section">
        <div class="cta-container">
            <div class="cta-section-container max-width-container">
                <h2 class="section-title">{{ 'landing.cta.title' | transloco }}</h2>
                <div class="cta-content">
                    <img class="cta-image" src="/assets/images/landing/final-cta.jpg">
                    <div class="cta-content-right">
                        <div class="cta-content-right-detail">
                            <h3 style="color: #FFF6C6;">{{ 'landing.cta.header' | transloco }}</h3>
                            <p class="body-hyper">{{ 'landing.cta.body' | transloco }}</p>
                        </div>
                        <a href="{{ 'landing.navbar.solutions.lastMile.href' | transloco }}" target="_blank"
                            rel="noopener noreferrer" class="rad-btn-large rad-btn-default">
                            {{ 'landing.cta.shipWithRadishToday' | transloco }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="footer">
        <div class="footer-container">
            <div class="footer-section-container max-width-container">
                <div class="footer-logo-container">
                    <img id="footer-logo" src="/assets/images/radish-logos/Radish-Logo-BlackText-Large.png"
                        alt="Radish" />
                </div>
                <div class="footer-content">
                    <div class="footer-controls-container">
                        <div class="footer-controls body-xlarge">
                            <a href="{{ 'landing.navbar.careers.href' | transloco }}" target="_blank"
                                rel="noopener noreferrer">
                                {{ 'footer.becomeACourierAlt' | transloco}}
                            </a>
                            <div class="footer-divider"></div>
                            <a [routerLink]="'/' + translate.getActiveLang() + '/restaurants'">
                                {{ 'footer.restaurant' | transloco}}
                            </a>
                            <div class="footer-divider"></div>
                            <a [routerLink]="'/' + translate.getActiveLang() + '/privacy'">
                                {{ 'footer.privacy' | transloco}}
                            </a>
                        </div>
                        <div class="footer-divider middle-divider"></div>
                        <div class="footer-controls body-xlarge">
                            <a [routerLink]="'/' + translate.getActiveLang() + '/terms'">
                                {{ 'footer.terms' | transloco}}
                            </a>
                            <div class="footer-divider"></div>
                            <a href="mailto:support@radish.coop" target="_blank">
                                {{ 'footer.contact' | transloco}}
                            </a>
                            <div class="footer-divider"></div>
                            <a href="{{ 'landing.navbar.solutions.lastMile.href' | transloco }}" target="_blank"
                                rel="noopener noreferrer">
                                {{ 'footer.demo' | transloco}}
                            </a>
                            <div class="footer-divider"></div>
                            <a [routerLink]="'/' + translate.getActiveLang() + '/horseradish'">
                                Horseradish
                            </a>
                        </div>
                    </div>

                    <div class="social-media-container">
                        <a href="https://facebook.com/radish.coop" target="_blank" title="" class="facebook">
                            <svg class="footer-social-media-icon" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                                <path
                                    d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5l0-170.3-52.8 0 0-78.2 52.8 0 0-33.7c0-87.1 39.4-127.5 125-127.5 16.2 0 44.2 3.2 55.7 6.4l0 70.8c-6-.6-16.5-1-29.6-1-42 0-58.2 15.9-58.2 57.2l0 27.8 83.6 0-14.4 78.2-69.3 0 0 175.9C413.8 494.8 512 386.9 512 256z" />
                            </svg>
                        </a>
                        <a href="https://www.instagram.com/radish.coop/" target="_blank" title="" class="instagram">
                            <svg class="footer-social-media-icon" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                                <path
                                    d="M224.3 141a115 115 0 1 0 -.6 230 115 115 0 1 0 .6-230zm-.6 40.4a74.6 74.6 0 1 1 .6 149.2 74.6 74.6 0 1 1 -.6-149.2zm93.4-45.1a26.8 26.8 0 1 1 53.6 0 26.8 26.8 0 1 1 -53.6 0zm129.7 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM399 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                            </svg>
                        </a>
                        <a href="https://twitter.com/RadishCoop" target="_blank" title="" class="twitter">
                            <svg class="footer-social-media-icon" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                                <path
                                    d="M459.4 151.7c.3 4.5 .3 9.1 .3 13.6 0 138.7-105.6 298.6-298.6 298.6-59.5 0-114.7-17.2-161.1-47.1 8.4 1 16.6 1.3 25.3 1.3 49.1 0 94.2-16.6 130.3-44.8-46.1-1-84.8-31.2-98.1-72.8 6.5 1 13 1.6 19.8 1.6 9.4 0 18.8-1.3 27.6-3.6-48.1-9.7-84.1-52-84.1-103l0-1.3c14 7.8 30.2 12.7 47.4 13.3-28.3-18.8-46.8-51-46.8-87.4 0-19.5 5.2-37.4 14.3-53 51.7 63.7 129.3 105.3 216.4 109.8-1.6-7.8-2.6-15.9-2.6-24 0-57.8 46.8-104.9 104.9-104.9 30.2 0 57.5 12.7 76.7 33.1 23.7-4.5 46.5-13.3 66.6-25.3-7.8 24.4-24.4 44.8-46.1 57.8 21.1-2.3 41.6-8.1 60.4-16.2-14.3 20.8-32.2 39.3-52.6 54.3z" />
                            </svg>
                        </a>
                        <a href="https://www.linkedin.com/company/radishcoop" target="_blank" title="" class="linkedin">
                            <svg class="footer-social-media-icon" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                                <path
                                    d="M416 32L31.9 32C14.3 32 0 46.5 0 64.3L0 447.7C0 465.5 14.3 480 31.9 480L416 480c17.6 0 32-14.5 32-32.3l0-383.4C448 46.5 433.6 32 416 32zM135.4 416l-66.4 0 0-213.8 66.5 0 0 213.8-.1 0zM102.2 96a38.5 38.5 0 1 1 0 77 38.5 38.5 0 1 1 0-77zM384.3 416l-66.4 0 0-104c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9l0 105.8-66.4 0 0-213.8 63.7 0 0 29.2 .9 0c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9l0 117.2z" />
                            </svg>
                        </a>
                    </div>
                    <div class="footer-made-with">
                        <h5>{{ 'footer.madeInMtlWith' | transloco }}</h5>
                        <svg class="footer-made-with-heart" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"><!--!Font Awesome Free v5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                            <path
                                d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z" />
                        </svg>
                    </div>
                    <p class="copyright">{{ 'footer.copyright' | transloco }}</p>
                </div>

                <!-- mobile footer -->
                <div class="footer-content-mobile">
                    <div class="merchant-courier-row label">
                        <a href="{{ 'landing.navbar.careers.href' | transloco }}" target="_blank"
                            rel="noopener noreferrer">
                            {{ 'footer.becomeACourierAlt' | transloco}}
                        </a>
                        <a [routerLink]="'/' + translate.getActiveLang() + '/restaurants'">
                            {{ 'footer.restaurant' | transloco}}
                        </a>
                    </div>
                    <div class="more-detail-container">
                        <div class="more-detail-content">
                            <a [routerLink]="'/' + translate.getActiveLang() + '/privacy'">
                                {{ 'footer.privacy' | transloco}}
                            </a>
                            <a [routerLink]="'/' + translate.getActiveLang() + '/terms'">
                                {{ 'footer.terms' | transloco}}
                            </a>
                            <a href="mailto:support@radish.coop" target="_blank">
                                {{ 'footer.contact' | transloco}}
                            </a>
                            <a href="{{ 'landing.navbar.solutions.lastMile.href' | transloco }}" target="_blank"
                                rel="noopener noreferrer">
                                {{ 'footer.demo' | transloco}}
                            </a>
                            <a [routerLink]="'/' + translate.getActiveLang() + '/horseradish'">
                                Horseradish
                            </a>
                        </div>
                        <div class="social-media-container">
                            <a class="footer-social-media-icon" href="https://facebook.com/radish.coop" target="_blank"
                                title="" class="facebook">
                                <img src="/assets/images/social-media-icons/facebook-logo-black.png" />
                            </a>
                            <a class="footer-social-media-icon" href="https://www.instagram.com/radish.coop/"
                                target="_blank" title="" class="instagram">
                                <img src="/assets/images/social-media-icons/instagram-logo.png" />
                            </a>
                            <a class="footer-social-media-icon" href="https://twitter.com/RadishCoop" target="_blank"
                                title="" class="twitter">
                                <img src="/assets/images/social-media-icons/twitter-logo.png" />
                            </a>
                            <a class="footer-social-media-icon" href="https://www.linkedin.com/company/radishcoop"
                                target="_blank" title="" class="linkedin">
                                <img src="/assets/images/social-media-icons/linkedin-logo-black.png" />
                            </a>
                        </div>
                    </div>
                    <div class="footer-copyright">
                        <div class="footer-made-with">
                            <h5>{{ 'footer.madeWith' | transloco }}</h5>
                            <svg class="footer-made-with-heart" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"><!--!Font Awesome Free v5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
                                <path
                                    d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z" />
                            </svg>
                        </div>
                        <p class="copyright">{{ 'footer.copyrightAlt' | transloco }}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
